/*
saikrishna 11/03/2022 3075154998 changed the paginationOptions
 */
import React, {createRef, useState} from 'react';
// import MaterialTable from "material-table";
import {TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function FiltersSystemNotes({
  filterCode,
  filterCodeName,
}) {
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Type',
      field: 'noteType',
    },
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Filter Code',
      field: 'filterCode',
      render: (rowData) => <>{rowData?.code}</>,
    },
    {
      title: 'Note Text',
      field: 'noteText',
      type: 'string',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
  ];

  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);

  return (
    <div className="global-field-table">
      <GuiTable
        title=""
        columns={columns}
        icons={tableIcons}
        tableRef={tableRef}
        data={(query) =>
          new Promise((resolve) => {
            const url = `enableintegration/find/all/notes`;
            const bodyObj = {
              code: filterCodeName,
              limit: rows,
              orderBy: '',
              orderDirection: '',
              search: '',
              page:
                arrayLast && query.page >= 1 ?
                  query.page :
                  arrayLast ?
                    (query.page <= 1 && query.page + 1) || query.page - 1 :
                    query.page + 1,
            };
            if (!filterCode) {
              resolve({
                data: [],
                page: 0,
                totalCount: 5,
              });
            } else {
              httpPaginationPost(url, bodyObj)
                .then((response) => {
                  if (response?.status === 200) {
                    const data = response.data.response.resultObjects;
                    resolve({
                      data: data.length > 0 ? data : [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    setArrayLast(response.data.response.resultObjects.length === 1);
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                .catch((response) => {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                });
            }
          })
        }
        options={{
          toolbar: false,
          search: false,
          pageSize: rows,
          showSelectAllCheckbox: false,
          emptyRowsWhenPaging: false,
          pageSizeOptions: tablePageRows,
          headerStyle: {
            fontWeight: 'bold',
          },
        }}
        components={{
          Pagination: (props) => (
            <TablePagination
              {...props}
              rowsPerPageOptions={tablePageRows}
              onChangeRowsPerPage={(event) => {
                props.onChangeRowsPerPage(event);
                setRows(event.target.value);
              }}
            />
          ),
        }}
      />
    </div>
  );
}
